var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109.123,
    height: 94,
    viewBox: "0 0 109.123 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0f4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00baef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plant",
    transform: "translate(-258.501 -796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M-9561.5-7797.625a5.627,5.627,0,0,1,5.631-5.624,5.627,5.627,0,0,1,5.631,5.624,5.628,5.628,0,0,1-5.631,5.626A5.628,5.628,0,0,1-9561.5-7797.625Zm-29.721,3.615c-20.327-3.46-18.208-14.251-21.371-17.886-4.268-4.9-5.737.053-11.124-10.7-5.916-17,10.182-22.959,15.351-24.332-4.623-19.4,2.514-29.658,14.467-33.085s22.243,2.042,27.652,12.434c2.856,1.81,6.711.461,11.134-.887,3.85-1.174,8.13-2.347,12.56-1.436,14.51,2.985,28.343,15.46,26.509,34.409-1.109,8.272-8.456,22.277-24.218,26.41-3.971,1.039-9.065.457-14.184-.126a71.1,71.1,0,0,0-10.039-.681c-4.911.161-8.771,16.2-23.125,16.2A21.44,21.44,0,0,1-9591.217-7794.01Zm-32.831-56.239a4.5,4.5,0,0,1,4.5-4.5,4.5,4.5,0,0,1,4.5,4.5,4.5,4.5,0,0,1-4.5,4.5A4.5,4.5,0,0,1-9624.048-7850.25Zm59.3-30.25a5.5,5.5,0,0,1,5.5-5.5,5.5,5.5,0,0,1,5.506,5.5,5.5,5.5,0,0,1-5.506,5.5A5.5,5.5,0,0,1-9564.749-7880.5Z",
    transform: "translate(9883.5 8682)",
    opacity: 0.815,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-potted_plant",
    transform: "translate(274.217 808.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M27.853,33.539h0a1.812,1.812,0,0,1-1.808-1.808c0-.181.181-10.124-5.966-13.921a1.83,1.83,0,1,1,1.989-3.073c7.955,5.062,7.774,16.633,7.774,17.175A2.118,2.118,0,0,1,27.853,33.539Z",
    transform: "translate(10.69 6.791)",
    fill: "#8bc34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M31.672,7.788C22.994,3.449,9.435,8.33,6,9.6c5.062,3.073,4.339,19.706,13.559,22.78,6.508,2.169,11.571-.362,12.113-9.4C38.9,18.816,37.819,10.861,31.672,7.788Zm6.87,37.966a1.708,1.708,0,0,1-1.808-1.808V38.522c0-14.1,10.486-16.271,10.486-16.271A1.983,1.983,0,0,1,49.39,23.7a1.983,1.983,0,0,1-1.446,2.169c-.362,0-7.593,1.627-7.593,12.655v5.424A1.708,1.708,0,0,1,38.542,45.754Z",
    transform: "translate(0 0)",
    fill: "#8bc34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M32.806,8.533c7.955-2.531,18.8,4.881,21.333,6.689-4.7,1.808-7.774,16.814-16.09,17.9-5.785.723-8.859-2.35-7.412-10.667C24.128,17.392,27.2,10.16,32.806,8.533Z",
    transform: "translate(16.945 1.605)",
    fill: "#8bc34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M19.559,30.78C10.339,27.706,11.062,11.073,6,8c4.52.362,11.028,4.339,25.672,13.379C31.13,30.418,26.249,32.949,19.559,30.78Zm35.616,2.35c8.136-1.085,11.209-16.09,16.09-17.9-3.8-.542-9.763,1.627-23.5,7.232C44.689,30.6,49.209,34.034,55.175,33.13Z",
    transform: "translate(0 1.595)",
    fill: "#689f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M13,27l5.424,27.119H47.35L52.774,27Z",
    transform: "translate(5.655 16.946)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M53.582,34.04H13.808A1.812,1.812,0,0,1,12,32.232V25H55.39v7.232A1.944,1.944,0,0,1,53.582,34.04Z",
    transform: "translate(4.847 15.33)",
    fill: "url(#linear-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.6dc39f55db2355f473bde9c1ecbb2097.svg";
export { ForwardRef as ReactComponent };